import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsOutline, PtPermissions} from '@pt/pt-models';

@Component({
  selector: 'pt-widget-action',
  templateUrl: './widget-action.component.html',
  styleUrls: ['./widget-action.component.scss']
})
export class WidgetActionComponent {

  @Input() actionStyle: 'BUTTON' | 'TEXT' = 'BUTTON';

  @Input() showEdit: boolean;
  @Input() showCancel: boolean;
  @Input() showSave: boolean;
  @Input() showLoader: boolean;
  @Input() showReload: boolean;

  @Input() showIcon: boolean;

  @Input() disabledEdit: boolean;
  @Input() disabledCancel: boolean;
  @Input() disabledSave: boolean;
  @Input() disabledReload: boolean;

  @Output() clickEdit = new EventEmitter();
  @Output() clickCancel = new EventEmitter();
  @Output() clickSave = new EventEmitter();
  @Output() clickReload = new EventEmitter();

  IconEdit = IoniconsOutline.edit;
  IconSave = IoniconsOutline.save;
  IconReload = IoniconsOutline.reload;
  IconClose = IoniconsOutline.close;

  IconSize = 16;

  PtPermissions = PtPermissions;

}
